import clsx from "clsx";
import React from "react";
import { makeStyles } from "tss-react/mui";

import { TableRow } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    row: {
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.listHover,
        },
    },
    selected: {
        backgroundColor: theme.palette.emteria.background.selectedRow,
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.selectedRow,
        },
    },
    clickable: {
        cursor: "pointer",
    },
    notClickable: {
        cursor: "default",
    },
}));

type HoverRowProps = React.PropsWithChildren<{
    selected?: boolean;
    clickable?: boolean;
    className?: string;
    style?: React.CSSProperties;
    onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
    rowProps?: React.HTMLAttributes<HTMLTableRowElement>;
}>;

export const HoverRow = React.forwardRef<HTMLTableRowElement, HoverRowProps>((props, ref) => {
    const { classes } = useStyles();
    const clickable = props.clickable !== false;

    return (
        <TableRow
            ref={ref}
            {...props.rowProps}
            className={clsx(
                classes.row,
                props.selected && classes.selected,
                clickable ? classes.clickable : classes.notClickable,
                props.className,
            )}
            style={props.style}
            onClick={props.onClick}
        >
            {props.children}
        </TableRow>
    );
});
